<template>
  <div class="select-content" @click="isShowSelect = true" v-clickoutside="hanldeClickoutside">
    <ul class="value-content" v-if="values.length > 0">
      <li v-for="(item, index) in values" :key="index">
        {{ item.name }}
       
           <el-input v-model="item.count" type='number' min="1" max="50" class="query"
              @change="handlerInputChange" style="width:60px;height:10px;top:-9px">
            </el-input>
        <i class="el-icon-error" style="color:#909399" @click="handleDeleteValue(index)"></i>
      </li>
    </ul>
    <div class="value-content no-select" v-else>
      {{ placeholder }}
    </div>
    <div :class="{ 'right-icon': true, 'is-reverse': isShowSelect }">
      <i class="el-icon-arrow-up"></i>
    </div>
    <el-popover ref="popover" v-model="isShowSelect" placement="top-start" :width="width" trigger="click" :offset="200">
      <ul class="options-list">
        <li :class="{
          'options-item': true,
          'is-selected': isSelect(item)
        }" v-for="(item, index) in options" :key="index" @click="handleSelectChange(item)">
          {{ item.name }}
        </li>
      </ul>
      <div class="popper__arrow" style="left: 85.5px;">

      </div>
    </el-popover>
  </div>
</template>

<script>
const clickoutsideContext = '@@clickoutsideContext'
export default {
  name: 'select-input',
  props: ['options', 'value', 'placeholder'],
  template: '#select-template',
  directives: {
    clickoutside: {
      bind(el, binding, vnode) {
        const documentHandler = function (e) {
          if (!vnode.context || el.contains(e.target)) {
            return false
          }
          if (binding.expression) {
            vnode.context[el[clickoutsideContext].methodName](e)
          } else {
            el[clickoutsideContext].bindingFn(e)
          }
        }
        el[clickoutsideContext] = {
          documentHandler,
          methodName: binding.expression,
          bindingFn: binding.value,
        }
        setTimeout(() => {
          document.addEventListener('click', documentHandler)
        }, 0)
      },
      update(el, binding) {
        el[clickoutsideContext].methodName = binding.expression
        el[clickoutsideContext].bindingFn = binding.value
      },
      unbind(el) {
        document.removeEventListener('click', el[clickoutsideContext].documentHandler)
      },
      install(Vue) {
        Vue.directive('clickoutside', {
          bind: this.bind,
          unbind: this.unbind,
        })
      },
    }
  },
  data() {
    return {
      width: 200,
      isShowSelect: false,
      selectValue: [],
      values: [

      ]
    }
  },
  watch: {
    value: {
      handler(value) {
        if (value.length > 0) {
          if (JSON.stringify(value) !== JSON.stringify(this.values)) {
            value.map(item => {
              return {
                ...item
              }
            }).forEach(i => {
              this.values.push(i)
            });
          }
        } else {
          if (this.values.length > 0) {
            this.values.splice(0)
            this.$emit('input', [])
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    isSelect() {
      
      return function (item) {
        const flag = this.values.some(i => {
          
          return i.id == item.id
        })
        return flag
      }
    }
  },
  mounted: function () {
  },
  methods: {
    handleSelectChange(item) {  
      const flag = this.values.some(i => {
        return i.id == item.id
      })
      if (!flag) this.values.push({ ...item, count: 1 })
      this.$emit('input', this.values)
    },
    handleDeleteValue(index) {
      this.values.splice(index, 1)
      this.$emit('input', this.values)
    },
    handlerInputChange() {
    },
    hanldeClickoutside() {
      this.$emit('input', this.values)
      if (!this.isShowSelect) return
      this.isShowSelect = false

    },
  }
}

</script>

<style>
ul {
  margin: 0;
  padding: 0;
}

.select-content {

  min-height: 28px;
  border: 1px solid;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding-right: 30px;
}

.select-content:hover {
  border-color: #409eff;
}

.select-content .right-icon {
  position: absolute;
  width: 30px;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 14px;
  transition: transform .3s;
  transform: rotate(180deg);
  cursor: pointer;
}

.select-content .right-icon.is-reverse {
  transform: rotate(0deg);
}

.select-content .value-content {
  display: flex;
  min-height: 36px;
  min-width: 350px;
  padding: 0 10px;
  list-style: none;
  align-items: center;
  flex-wrap: wrap;
}

.value-content>li {
  display: flex;
  list-style: none;
  align-items: center;
  margin-right: 10px;
  padding: 5px 0;
}

.value-content .el-icon-error {
  margin-left: 4px;
}

.value-content.no-select {
  user-select: none;
  color: #c0c4cc;
  
}


.el-popover {
  padding: 0;
  margin-top: 10px;
}

.el-popover .popper__arrow {
  top: 0;
  position: absolute;
}

.el-popover .popper__arrow::after {
  content: " ";
  border-width: 6px;
  top: -10px;
  margin-left: -50px;
  border-top-width: 0;
  border-bottom-color: #fff;
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
}


.options-list {
  list-style: none;
  padding: 6px 0;
  margin: 0;
  box-sizing: border-box;
}

.options-item {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
  cursor: pointer;
}

.options-item:hover {
  background-color: #f5f7fa;
}

.options-item.is-selected {
  color: #409eff;
  font-weight: 700;
}

.options-item.is-selected::after {
  position: absolute;
  right: 20px;
  font-family: element-icons;
  content: "\e6da";
  font-size: 12px;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
.query{
  margin: 5px;
}
</style>
